import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

const AnimateComp = ({
  children,
  animationType,
  partVisible = true,
  minTop = '0',
  scrollDelay = '50',
}) => {
  const [isShow, setIsShow] = useState(false);

  const handleShow = (isVisible) => {
    if (isVisible || isShow) {
      setIsShow(true);
    }
  };

  return (
    <VisibilitySensor
      onChange={handleShow}
      scrollDelay={scrollDelay}
      partialVisibility={partVisible}
      minTopValue={minTop}
    >
      {() =>
        children({
          className: isShow ? animationType : 'hidden',
        })
      }
    </VisibilitySensor>
  );
};

export default AnimateComp;
